import React, { FunctionComponent } from "react";
import { NodeProps } from "reactflow";
import {
  BasicNodeLayout,
  DocumentSchemaSource,
  IoType,
  NodeSize,
  NodeType,
  NodeTypeCategory,
  NodeOperationIcon
} from "../Base";
import { NodeConfigPropertyType } from "../../FlowDocument/PropertyTypeDefinitions";
import { DataType } from "../TypeDefinitions";
import { noReferenceSchemaId } from "../DataSchemas";

globalThis.nodeTypeDefinitions.setDefinition({
  nodeType: NodeType.callCustomObjectGet,
  label: "Get Custom Object Data",
  operationIcon: NodeOperationIcon.get,
  category: NodeTypeCategory.services,
  size: NodeSize.Small,
  controlInputs: [{ name: "call" }],
  controlOutputs: [{ name: "completed", label: "" }],
  dataInputs: [{ name: "identifier", label: "ID", type: DataType.OBJECTREFERENCE, schemaId: noReferenceSchemaId }],
  dataOutputs: [{ name: "fields", type: DataType.OBJECT }],
  nodeConfigProperties: [
    {
      name: "customObjectId",
      label: "Custom Object",
      propertyType: NodeConfigPropertyType.CustomObject,
      schemaSourceSystemType: DocumentSchemaSource.customObject,
      schemaSystem: { createIo: true, ioType: IoType.get }
    },
    {
      name: "customObjectName",
      label: "Custom Object Name",
      propertyType: NodeConfigPropertyType.NoInput,
      schemaSourceSystemType: DocumentSchemaSource.customObject
    }
  ],
  skipEvaluate: true,
  evaluate: () => {
    return { output: {}, activeControlHandleIds: [] };
  }
});

export const CallCustomObjectGetNode: FunctionComponent<NodeProps> = ({ id, data }) => {
  let label = "Get Custom Object Data";
  if (data.nodeProperties.customObjectName) {
    label = `Get ${data.nodeProperties.customObjectName} Custom Object Data`;
    data.nodeProperties.label = label;
  }
  return <BasicNodeLayout id={id} data={data} label={label} />;
};
